<template>
  <div class="set_smail_line">
    <el-form :model="passForm" :rules="passRules" ref="passForm" :hide-required-asterisk='true' class="set_form">
      <el-form-item :label="$t('colon.phoneNumber')" class="info_box" prop="phone">
        <el-input class="info_ipt" v-model="passForm.phone"></el-input>
      </el-form-item>
      <div class="set_btn">
        <el-button @click="resetForm('passForm')">Cancel</el-button>
        <el-button type="primary" @click="submitForm('passForm')">Save</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'phonebox',
    data () {
      
      return {
        passForm:{
          phone:"",
        },
        passRules:{
          phone:[
            { required: true, message: 'Wrong phone.', trigger: 'blur'},
            { type: 'number', message: 'The phone number must be numeric'}//年龄必须为数字值
          ]
        }
      }
    },
    props: {
        list: Object,
    },
    methods: {
      submitForm(formName) {
        this.$emit('getData',this.list,'phone')
        this.$refs[formName].validate((valid) => {
          if (valid) {
            alert('submit!');
          } else {
            alert('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.$emit('getData',this.list,'phone')
      }
  } 
  }
</script>

<style scoped>
@import "../../../static/css/settings.css";
</style>

          


// WEBPACK FOOTER //
// src/components/form/phone.vue